import { BusinessRole } from "fe-shared/src/types/domain";
import {
  DocumentsResponse,
  TransactionWarehouse,
  TransactionFlag,
  ScaleTicket,
  TransactionUser,
  Assignee,
} from "./details";
import {
  NonEligibleItem,
  TransactionMaterial,
  TransactionTraversedMaterial,
} from "./materials";
import { NoteRecord } from "./notes";

export enum TransferType {
  IntoProcessing = "IntoProcessing",
  OutOfProcessing = "OutOfProcessing",
  DeliveryToStorage = "DeliveryToStorage",
  PickupFromStorage = "PickupFromStorage",
  NonEligibleWriteOff = "NonElMaterialWriteOff",
  NonEligibleBufferWriteOff = "NonElMaterialWriteOff2",
}
export enum TransferStatus {
  Submitted = "Submitted",
  InReview = "Reviewing",
  Approved = "Approved",
  Invoiced = "Invoiced",
  Invalid = "Invalid",
}
export interface TransferResponse<
  T extends TransferListItem = TransferListItem
> {
  total: number;
  transfers: T[];
}
export interface CompanyCreator {
  regNumber: number;
  businessRoleCode: BusinessRole;
  companyId: number;
  displayName: string;
}

export interface TransferInfoResponse {
  transfer: Transfer;
}

export interface Transfer {
  transferId: number;
  transferNumber: string;
  completedDate: string;
  submittedDate: string;
  initiatedDate: string;
  assignedToDisplayName: string;
  assignedToId: number;
  transferType: TransferType;
  participantRegNumber: string;
  participantDisplayName: string;
  createdBy: string;
  statusCode: TransferStatus;
  syncedDate: string;
  materials: TransactionMaterial[];
  traversedMaterials?: TransactionTraversedMaterial[] | null;
  grossWeight: number;
  tareWeight: number;
  materialAttributes: string[];
  companyCreator: CompanyCreator;
  sourceWarehouse?: TransactionWarehouse;
  targetWarehouse: TransactionWarehouse;
  materialPhotos: string[];
  paperFormImages?: string[];
  comment: string;
  attachments?: DocumentsResponse[];
  nonEligibleItems?: NonEligibleItem[];
  transferFlags: TransactionFlag[];
  invoiceNumber?: string;
  isPaperForm: boolean;
  isCorrected: boolean;
  isAdjustable: boolean;
  nonEligibleMaterial?: TransactionMaterial;
  regulatoryYear?: string | null;
  scaleTickets?: ScaleTicket[];
  invalidatedBy?: TransactionUser;
  invalidationDate: string | null;
  invalidationReason: string | null;
  assignee?: Assignee | null;
  isInClosurePeriod: boolean;
  paymentAmount?: number | null;
  actualTransactionDate?: string | null;
}

export interface TransferListItem {
  createdBy: string;
  completedDate: string;
  transferType: TransferType;
  participantRegNumber: string;
  participantDisplayName: string;
  statusCode: TransferStatus;
  transferId: number;
  transferNumber: string;
  hasAutoFlag?: boolean;
  invoiceNumber?: string;
  isPaperForm: boolean;
  isInvoiceable: boolean;
  isAdjustable: boolean;
  syncedDate?: string;
}

export interface GridTransferExport extends TransferListItem {
  totalWeight: number;
  materials: TransactionMaterial[];
  nonEligibleMaterial?: TransactionMaterial;
  historyLogs?: NoteRecord[];
  notes?: NoteRecord[];
  isEdited: boolean;
  sortYardId: number;
}
